import { render, staticRenderFns } from "./MainMenuEntry.vue?vue&type=template&id=1838cd49&scoped=true&"
import script from "./MainMenuEntry.vue?vue&type=script&lang=ts&"
export * from "./MainMenuEntry.vue?vue&type=script&lang=ts&"
import style0 from "./MainMenuEntry.vue?vue&type=style&index=0&id=1838cd49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838cd49",
  null
  
)

export default component.exports